/**
 * @generated SignedSource<<81b1385fb019eeb4e49d71489fed7728>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CleanupProjectPageUseIsReadOnlyQuery$variables = {
  locator: string;
};
export type CleanupProjectPageUseIsReadOnlyQuery$data = {
  readonly projectsRest: {
    readonly " $fragmentSpreads": FragmentRefs<"CleanupProjectPageUseIsReadOnlyFragment">;
  } | null | undefined;
};
export type CleanupProjectPageUseIsReadOnlyQuery = {
  response: CleanupProjectPageUseIsReadOnlyQuery$data;
  variables: CleanupProjectPageUseIsReadOnlyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "locator",
    "variableName": "locator"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CleanupProjectPageUseIsReadOnlyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Projects",
        "kind": "LinkedField",
        "name": "projectsRest",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CleanupProjectPageUseIsReadOnlyFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "CleanupProjectPageUseIsReadOnlyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Projects",
        "kind": "LinkedField",
        "name": "projectsRest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectRest",
            "kind": "LinkedField",
            "name": "project",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "_id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c51814d1e489d5b2dea73d4081191419",
    "id": null,
    "metadata": {},
    "name": "CleanupProjectPageUseIsReadOnlyQuery",
    "operationKind": "query",
    "text": "query CleanupProjectPageUseIsReadOnlyQuery(\n  $locator: String!\n) {\n  projectsRest(locator: $locator) {\n    ...CleanupProjectPageUseIsReadOnlyFragment\n  }\n}\n\nfragment CleanupProjectPageUseIsReadOnlyFragment on Projects {\n  project {\n    id\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "12d5bccfdc7a38f88b6cfc703b8e4ea0";

export default node;
